import { Component } from '@angular/core';

@Component({
    selector: 'app-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrl: './forgot-password-page.component.scss',
    standalone: false
})
export class ForgotPasswordPageComponent {

}
